export default {
	game: {
		maintenance: '점검 중',
		maintenance_tip: '일시적으로 이용할 수 없습니다',
		no_more_data: '더 이상 데이터가 없습니다',
		search_game_name: '게임 이름 검색...',
		selected: '선택됨',
		type: '유형',
		all_types: '모든 유형',
		secondary: '보조',
		secondary_category: '하위 분류',
		no_related_games: '관련 게임을 찾을 수 없습니다',
		reset_all: '모두 초기화',
		end_of_list: '리스트 끝',
		game_details: '게임 상세',
		play: '플레이',
		bonus_cannot_wagered: '보너스는 베팅할 수 없습니다',
		entering_game: '게임 입장 중입니다. 잠시만 기다려주세요...',
		entering_game_short: '게임 입장 중...',
		game_types: '게임 유형',
		game_providers: '게임 제공사',
		sign_up: '회원가입',
		search: '검색',
		all_providers: '모든 제공사',
		loading: '로딩 중...',
		my_bet: '나의 베팅'
	}
};